import { FetchProofreadEventsApi } from 'api/mypage/proofread_plans/proofread_event';
import { PartnerFetchProofreadEventsApi } from 'api/partner/proofread_plans/proofread_event';
import { DropDownCheckboxItem } from 'components/shared/form/input';
import { InstrumentFilter } from 'entities/instrument';
import { ProofreadEventSearchForm } from 'entities/proofread_event';
import { Form } from 'rac';

export type ProofreadEventFilterSet = {
  searchForm: Form<ProofreadEventSearchForm>;
  handleSearch: () => void;
  makersOptions: () => DropDownCheckboxItem[];
  modelNumbersOptions: () => DropDownCheckboxItem[];
  manageNumbersOptions: () => DropDownCheckboxItem[];
  instrumentCategoryNamesOptions: () => DropDownCheckboxItem[];
};

export const useProofreadEventFilter = (
  filter: InstrumentFilter,
  searchForm: Form<ProofreadEventSearchForm>,
  indexApi: FetchProofreadEventsApi | PartnerFetchProofreadEventsApi
): ProofreadEventFilterSet => {
  const handleSearch = () => {
    indexApi.executeAndPageReset();
  };

  const makersOptions = () => {
    const uniqueMakers = Array.from(new Set(filter.makers));
    const options: DropDownCheckboxItem[] = uniqueMakers.map((maker) => {
      return { value: maker, label: maker };
    });

    return options;
  };

  const modelNumbersOptions = () => {
    const uniqueModelNumbers = Array.from(new Set(filter.modelNumbers));
    const options: DropDownCheckboxItem[] = uniqueModelNumbers.map((modelNumber) => {
      return { value: modelNumber, label: modelNumber };
    });

    return options;
  };

  const manageNumbersOptions = () => {
    const uniqueManageNumbers = Array.from(new Set(filter.manageNumbers));
    const options: DropDownCheckboxItem[] = uniqueManageNumbers.map((manageNumber) => {
      if (manageNumber.length === 0) {
        return { value: '', label: '未指定' };
      } else {
        return { value: manageNumber, label: manageNumber };
      }
    });

    return options;
  };

  const instrumentCategoryNamesOptions = () => {
    const uniqueInstrumentCategories = Array.from(new Set(filter.instrumentCategoryFilter.instrumentCategories));
    const options: DropDownCheckboxItem[] = uniqueInstrumentCategories.map((category) => {
      return { value: String(category.id!), label: category.name! };
    });

    if (filter.instrumentCategoryFilter.includeNil) {
      options.unshift({ value: '', label: '未設定' });
    }

    return options;
  };

  return {
    searchForm,
    handleSearch,
    makersOptions,
    modelNumbersOptions,
    manageNumbersOptions,
    instrumentCategoryNamesOptions,
  };
};
